import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import { dashboardClienteAction } from 'components/ApplicationInsights/eventNames';
import { MenuItem } from 'components/MenuItems';
import Text from 'components/Text';

import transportHealthLog from 'img/transportHealthLog.png';
import cte from 'img/icon-ct-e.svg';
import xmlCte from 'img/icon-xml-ct-e.svg';

import { EnumCTEsTabsPage } from 'models/CTEs';

import {
  Container,
  Content,
  RowMenuItem,
  TextShippingCompany,
} from './styles';

export const ShippingCompany: React.FC = () => {

  const user = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userTypeIsCustomer: boolean = user?.userType === 'customer';

  const handleRedirectPageCte = (currentTabPage: string) => {
    dispatch({
      type: 'SET_CURRENT_TAB_PAGE',
      data: Number(currentTabPage)
    });

    navigate("/cte");
  };

  return (
    <Container userTypeIsCustomer={userTypeIsCustomer}>
      <Text size={24} className="color-primary font-bold pb-1">
        Health Log
      </Text>

      <Content userTypeIsCustomer={userTypeIsCustomer}>
        <img
          src={transportHealthLog}
          alt="Caminhão da empresa HealthLog."
          className="imgShippingCompany"
        />

        <div className="textShippingCompany">
          <TextShippingCompany>
            Somos o operador logístico especializado no mercado da saúde, com foco no segmento hospitalar.
            Oferecemos serviços especializados, equipe altamente capacitada e a maior frota dedicada ao mercado hospitalar no Brasil.
            Percorremos mais de 900 mil quilômetros por mês que garantem entregas rápidas em todo território nacional.
          </TextShippingCompany>
        </div>

        <RowMenuItem className='grid-gap-1 grid-gap-3 buttonShippingCompany'>
          <MenuItem
            title="CONSULTA"
            subtitle="DE CT-e"
            icon={cte}
            trackName={dashboardClienteAction.DASHCLIENTE_CONSULTACTE}
            onClick={() => handleRedirectPageCte(EnumCTEsTabsPage.LISTAGEM_CTES)}
          />

          <MenuItem
            title="CONSULTA DE"
            subtitle="FATURA"
            icon={xmlCte}
            trackName={dashboardClienteAction.DASHCLIENTE_CONSULTAFATURA}
            onClick={() => handleRedirectPageCte(EnumCTEsTabsPage.FATURAMENTO_CTES)}
          />

          <MenuItem
            title="CONSULTA"
            subtitle="DE ESTOQUE"
            icon={xmlCte}
            trackName={dashboardClienteAction.DASHCLIENTE_CONSULTAESTOQUE}
            onClick={() => handleRedirectPageCte(EnumCTEsTabsPage.ESTOQUE_CTES)}
          />
        </RowMenuItem>
      </Content>
    </Container>
  );
};